

export class ManuscriptsEditControllerConfig {
    submitRoute: string; // Route for submitting data on save
    modalIdTarget: string; // Modal id for the targeted popup
    isAdmin: boolean; // If this is for an admin (no readonly properties)
    tableVarName: string; // variable name for the table
}

export class ManuscriptsTableConfig {
    tableContainerId: string; // Where the table and filters will be placed on the page
    getManuscriptsRoute: string; // Route used for GET request for Manuscripts
    loadingContainerId: string // Id of the container showing loading indicator - show while loading
    loadedContentId: string // Id of the loaded content container - show after loading
    isEditable: boolean; // Allow items to be edited
    isAdmin: boolean; // If this is for an admin (no readonly properties)
    tableVarName: string; // name of the variable that is storing the Table item
    editModalId: string; // ID of the modal target for editing
    postRoute: string; // Route for posting AM saving
    addModalId: string; // ID of the modal target for adding
    additionalInfoModalId: string; // ID of modal target for additional information
    //Permissions for edit
    getEditableManuscriptIdsRoute: string;

}

export class ManuscriptsGroupFilterItem {
    categoryId: number;
    itemId: string;
    constructor(categoryId: number, itemId: string) {
        this.categoryId = categoryId;
        this.itemId = itemId;
    }
}
